import script from "./SBUs.vue?vue&type=script&setup=true&lang=js"
export * from "./SBUs.vue?vue&type=script&setup=true&lang=js"

import "./SBUs.vue?vue&type=style&index=0&id=64b449ce&lang=css"

const __exports__ = script;

export default __exports__